import { IonCard, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/react'
import { ellipsisHorizontal } from 'ionicons/icons'

import stopPropagation from '../../../lib/utils/stopPropagation'
import Button from '../../Button'
import CustomAvatarSkeleton from '../../CustomAvatar/CustomAvatarSkeleton'

import './style.scss'

const NetworkListItemSkeleton: React.FC = () => (
    <IonCard
        className='user-list-item'
    >
        <CustomAvatarSkeleton />

        <IonGrid
            className='user-list-item__grid'
        >
            <IonRow
                className='ion-align-items-center ion-justify-content-between ion-nowrap'
            >
                <IonCol>
                    <IonCardTitle>
                        <IonSkeletonText
                            style={{ width: '128px' }}
                        />
                    </IonCardTitle>
                    <IonRow>
                        <IonCardSubtitle>
                            <IonSkeletonText
                                style={{ width: '80px' }}
                            />
                        </IonCardSubtitle>
                    </IonRow>
                </IonCol>

                <IonCol
                    className='user-list-item__menu'
                >
                    <Button
                        disabled
                        onClick={stopPropagation}
                        size='small'
                        fill='clear'
                        icon={ellipsisHorizontal}
                    />
                </IonCol>
            </IonRow>
        </IonGrid>
    </IonCard>
)

export default NetworkListItemSkeleton
